import React from 'react';
import { Box } from '../../wag-react/next-components/box';
import { Flex } from '../Flex';
import { Symptom, SymptomValue } from '../Symptom';
import { Typography } from '../Typography';
export type SymptomListValue = SymptomValue[];
type Props = {
  value: SymptomListValue;
};
export const SymptomList = ({
  value
}: Props) => <>
    <Typography variant="body2" mb="16px" display="block" lineHeight="22px" data-sentry-element="Typography" data-sentry-source-file="index.tsx">
      My pet has the following
      {' '}
      <Box as="b" data-sentry-element="Box" data-sentry-source-file="index.tsx">
        symptoms:
      </Box>
    </Typography>
    <Flex flexWrap="wrap" gridGap="12px" mb={['16px', '20px']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
      {value.map(symptom => <Box key={symptom}>
          <Symptom value={symptom} />
        </Box>)}
    </Flex>
  </>;
export type SymptomListProps = Props;